import {
  ExtendedAllProductCategoryCode,
  TJournalProductPanelFilter,
  TParsedProductInstance,
  TProductCategory,
} from '@lib/core/products/types';
import { ILocation } from '@lib/core/users/types';
import { PRODUCT_CATEGORIES, PRODUCT_CATEGORIES_WITH_ALL } from '@lib/tools/shared/helpers/consts';

export interface IHandleProductsRequestParams {
  isPagination?: boolean;
  isFirstRequest?: boolean;
  isSearchRequest?: boolean;
  isJournalCase?: boolean;
}

export type IFilterProps = {
  additionalFiltersEnabled?: Record<string, boolean>;
  disabledFilters?: Record<string, boolean>;
  isSearchEnabled?: boolean;
  activeJournalPanelFilter?: TJournalProductPanelFilter;
};

/**
 * @todo improve api model through RTS @erfan
 */
export interface IRetailerCustomStyles {
  global: {
    backgroundColor: string;
  };
  header: {
    backgroundColor: string;
  };
  headerLogoImage: {
    backgroundImage: string;
  };
  quiz: {
    backgroundColor: string;
  };
  fidelityCardLogo: string;
  primaryColor: string;
  secondaryColor: string;
  theme: string;
}

export type ProductCategoryMedia = {
  [product in TProductCategory]?: {
    homeMedia?: string[];
    welcome?: string[];
  };
};

export interface IThemeCore {
  primaryColor: string;
  secondaryColor: string;
  theme: string;
  homeMedia?: string[];
  welcomeMedia?: string[];
}

export type ITheme = IThemeCore & ProductCategoryMedia;

export type TColorShadeKey = '25' | '50' | '100' | '200' | '300' | '400' | '500' | '600' | '700' | '800' | '900';
export type TColorShades = Record<TColorShadeKey, string>;

// This helps TS to be sure that a incoming string is a strict one from a provided set
export const isOneOf = <T extends readonly string[]>(arr: T, val: string): val is T[number] => {
  return (arr as readonly string[]).includes(val);
};

// To check if array items are exactly ILocation
export const isLocationArray = (array: TParsedProductInstance[] | ILocation[]): array is ILocation[] => {
  return array.length === 0 || array.every(item => 'retailer_location' in item || 'retailerLocation' in item);
};

// To check if array items are exactly TProductCategory
export const isProductCategory = (value: string): value is TProductCategory => {
  return Object.values(PRODUCT_CATEGORIES).some(category => category === value);
};

// To check if array items are exactly TProductCategory
export const isProductCategoryWithAll = (value: string): value is ExtendedAllProductCategoryCode => {
  return Object.values(PRODUCT_CATEGORIES_WITH_ALL).some(category => category === value);
};
